
export default function AutoSteeringLineupSection() {
  const products = [
    {
      id: 'fjd-at2-max',
      name: 'FJD AT2 Max',
      manufacturer: 'FJDynamics',
      category: '農機自動操舵システム',
      catchphrase: '最高精度の自動操舵を実現。\n大規模農場での作業効率を劇的に向上。',
      accuracy: 'RTK ±2.5cm',
      compatibility: '多種農機対応',
      targetUser: '大規模農場、精密農業を目指す農家',
      image: 'https://static.readdy.ai/image/b1b0be4a533f8dd52f529875d332f87d/a383448bf6a8455fc2670d6b2f0e2935.webp',
      features: [
        { icon: 'ri-navigation-line', text: 'RTK精度 ±2.5cm の高精度測位' },
        { icon: 'ri-settings-line', text: '多種農機への対応可能' },
        { icon: 'ri-user-line', text: '大規模農場、精密農業を目指す農家向け' }
      ]
    },
    {
      id: 'fjd-at2',
      name: 'FJD AT2',
      manufacturer: 'FJDynamics',
      category: '農機自動操舵システム',
      catchphrase: 'コストパフォーマンス重視。\n中規模農場に最適な自動操舵システム。',
      accuracy: 'RTK ±2.5cm',
      compatibility: '汎用農機対応',
      targetUser: '中規模農場、コスト重視の農家',
      image: 'https://static.readdy.ai/image/b1b0be4a533f8dd52f529875d332f87d/fb01fdf182259ba0f4e72f122c6af308.webp',
      features: [
        { icon: 'ri-navigation-line', text: 'RTK精度 ±2.5cm の実用的測位' },
        { icon: 'ri-settings-line', text: '汎用農機への簡単取付' },
        { icon: 'ri-user-line', text: '中規模農場、コスト重視の農家向け' }
      ]
    },
    {
      id: 'fjd-al02',
      name: 'FJD AL02',
      manufacturer: 'FJDynamics',
      category: 'RTKレベラーシステム',
      catchphrase: '圃場の均平化を自動化。\n水田の水管理効率を大幅改善。',
      accuracy: 'RTK ±2.5cm',
      compatibility: 'レベラー専用',
      targetUser: '水田農家、圃場整備事業者',
      image: 'https://static.readdy.ai/image/b1b0be4a533f8dd52f529875d332f87d/7cb9412fa5598ff3798d691af4b43407.webp',
      features: [
        { icon: 'ri-navigation-line', text: 'RTK精度 ±2.5cm の高精度レベリング' },
        { icon: 'ri-settings-line', text: 'レベラー作業専用設計' },
        { icon: 'ri-user-line', text: '水田農家、圃場整備事業者向け' }
      ]
    },
    {
      id: 'fjd-ats',
      name: 'FJD ATS',
      manufacturer: 'FJDynamics',
      category: '精密スプレーシステム',
      catchphrase: '薬剤散布の精密制御。\n環境負荷軽減と効果最大化を実現。',
      accuracy: 'RTK ±2.5cm',
      compatibility: 'スプレーヤー専用',
      targetUser: '大規模畑作農家、防除事業者',
      image: 'https://static.readdy.ai/image/b1b0be4a533f8dd52f529875d332f87d/b4f9f6d5bad9bb14dc10a69a0ab2c3ac.webp',
      features: [
        { icon: 'ri-navigation-line', text: 'RTK精度 ±2.5cm の精密散布' },
        { icon: 'ri-settings-line', text: 'スプレーヤー作業専用システム' },
        { icon: 'ri-user-line', text: '大規模畑作農家、防除事業者向け' }
      ]
    },
    {
      id: 'esteer-20-max',
      name: 'eSteer 20 MAX',
      manufacturer: 'EFIX',
      category: '農機自動操舵システム',
      catchphrase: '革新的な操舵技術。\n最新テクノロジーで農作業を変革。',
      accuracy: 'RTK ±2.5cm（※1）',
      compatibility: '多種農機対応',
      targetUser: '先進農業を目指す農家、大規模経営',
      image: 'https://static.readdy.ai/image/b1b0be4a533f8dd52f529875d332f87d/0ebc2d331fb79d2774321f2dabdc0a90.webp',
      features: [
        { icon: 'ri-navigation-line', text: 'RTK精度 ±2.5cm の高精度測位（※1）' },
        { icon: 'ri-speed-line', text: '超低速（0.1km/h）〜高速（30km/h）対応' },
        { icon: 'ri-user-line', text: '先進農業を目指す農家、大規模経営向け' }
      ]
    },
    {
      id: 'esteer-20',
      name: 'eSteer 20',
      manufacturer: 'EFIX',
      category: '農機自動操舵システム',
      catchphrase: 'シンプルで確実。\n導入しやすい自動操舵の入門モデル。',
      accuracy: 'RTK ±2.5cm',
      compatibility: '標準農機対応',
      targetUser: '中小規模農家、自動操舵初心者',
      image: 'https://public.readdy.ai/ai/img_res/bf0dccebaadfa87ab7b203b8613b494a.jpg',
      features: [
        { icon: 'ri-navigation-line', text: 'RTK精度 ±2.5cm の安定測位' },
        { icon: 'ri-speed-line', text: '超低速（0.1km/h）〜高速（30km/h）対応' },
        { icon: 'ri-user-line', text: '中小規模農家、自動操舵初心者向け' }
      ]
    }
  ];

  const handleViewDetails = (productId: string) => {
    window.REACT_APP_NAVIGATE(`/auto-steering/${productId}`);
  };

  return (
    <section className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-[#2A6041] mb-4">
            自動操舵システム ラインナップ
          </h2>
          <p className="text-xl text-gray-600">
            あなたの農場規模と作業内容に最適なシステムをお選びください
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {/* FJD AT2 Max */}
          <div className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-xl transition-shadow border border-gray-100">
            <div className="mb-6">
              <img 
                src="https://static.readdy.ai/image/b1b0be4a533f8dd52f529875d332f87d/a383448bf6a8455fc2670d6b2f0e2935.webp"
                alt="FJD AT2 Max"
                className="w-full h-64 object-cover rounded-lg"
              />
            </div>
            
            <div className="mb-4 flex flex-wrap gap-2">
              <span className="inline-block px-3 py-1 bg-[#76B947] text-white text-sm rounded-full">
                FJDynamics
              </span>
              <span className="inline-block px-3 py-1 bg-gray-100 text-gray-700 text-sm rounded-full">
                農機自動操舵システム
              </span>
            </div>

            <h3 className="text-2xl font-bold text-[#2A6041] mb-4">FJD AT2 Max</h3>
            
            <p className="text-gray-600 mb-6 leading-relaxed min-h-[3rem]">
              12.1インチモニターの大画面。<br />
              ISOBUS機器がより使いやすさが劇的に向上
            </p>

            <div className="space-y-3 mb-8 min-h-[8rem]">
              <div className="flex items-start text-sm text-gray-700">
                <div className="w-5 h-5 flex items-center justify-center mr-3 mt-0.5 flex-shrink-0">
                  <i className="ri-navigation-line text-[#76B947]"></i>
                </div>
                <span>RTK精度 ±2.5cm の高精度測位</span>
              </div>
              <div className="flex items-start text-sm text-gray-700">
                <div className="w-5 h-5 flex items-center justify-center mr-3 mt-0.5 flex-shrink-0">
                  <i className="ri-speed-line text-[#76B947]"></i>
                </div>
                <span>作業速度 0.5km/h〜12km/h（オプションで0.1km/h対応）</span>
              </div>
              <div className="flex items-start text-sm text-gray-700">
                <div className="w-5 h-5 flex items-center justify-center mr-3 mt-0.5 flex-shrink-0">
                  <i className="ri-settings-line text-[#76B947]"></i>
                </div>
                <span>多種農機への対応可能</span>
              </div>
              <div className="flex items-start text-sm text-gray-700">
                <div className="w-5 h-5 flex items-center justify-center mr-3 mt-0.5 flex-shrink-0">
                  <i className="ri-user-line text-[#76B947]"></i>
                </div>
                <span>大規模農場、精密農業を目指す農家向け</span>
              </div>
            </div>

            <div className="mt-auto">
              <button 
                onClick={() => handleViewDetails('fjd-at2-max')}
                className="w-full py-3 rounded-lg font-semibold whitespace-nowrap transition-colors bg-[#76B947] text-white hover:bg-[#2A6041] cursor-pointer"
              >
                詳細を見る
              </button>
            </div>
          </div>

          {/* FJD AT2 */}
          <div className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-xl transition-shadow border border-gray-100">
            <div className="mb-6">
              <img 
                src="https://static.readdy.ai/image/b1b0be4a533f8dd52f529875d332f87d/fb01fdf182259ba0f4e72f122c6af308.webp"
                alt="FJD AT2"
                className="w-full h-64 object-cover rounded-lg"
              />
            </div>
            
            <div className="mb-4 flex flex-wrap gap-2">
              <span className="inline-block px-3 py-1 bg-[#76B947] text-white text-sm rounded-full">
                FJDynamics
              </span>
              <span className="inline-block px-3 py-1 bg-gray-100 text-gray-700 text-sm rounded-full">
                農機自動操舵システム
              </span>
            </div>

            <h3 className="text-2xl font-bold text-[#2A6041] mb-4">FJD AT2</h3>
            
            <p className="text-gray-600 mb-6 leading-relaxed min-h-[3rem]">
              10.1インチモニターで操作性向上。<br />
              中規模農場に最適な自動操舵システム。
            </p>

            <div className="space-y-3 mb-8 min-h-[8rem]">
              <div className="flex items-start text-sm text-gray-700">
                <div className="w-5 h-5 flex items-center justify-center mr-3 mt-0.5 flex-shrink-0">
                  <i className="ri-navigation-line text-[#76B947]"></i>
                </div>
                <span>RTK精度 ±2.5cm の実用的測位</span>
              </div>
              <div className="flex items-start text-sm text-gray-700">
                <div className="w-5 h-5 flex items-center justify-center mr-3 mt-0.5 flex-shrink-0">
                  <i className="ri-speed-line text-[#76B947]"></i>
                </div>
                <span>作業速度 0.5km/h〜12km/h（オプションで0.1km/h対応）</span>
              </div>
              <div className="flex items-start text-sm text-gray-700">
                <div className="w-5 h-5 flex items-center justify-center mr-3 mt-0.5 flex-shrink-0">
                  <i className="ri-settings-line text-[#76B947]"></i>
                </div>
                <span>汎用農機への簡単取付</span>
              </div>
              <div className="flex items-start text-sm text-gray-700">
                <div className="w-5 h-5 flex items-center justify-center mr-3 mt-0.5 flex-shrink-0">
                  <i className="ri-user-line text-[#76B947]"></i>
                </div>
                <span>中規模農場、コスト重視の農家向け</span>
              </div>
            </div>

            <div className="mt-auto">
              <button 
                onClick={() => handleViewDetails('fjd-at2')}
                className="w-full py-3 rounded-lg font-semibold whitespace-nowrap transition-colors bg-[#76B947] text-white hover:bg-[#2A6041] cursor-pointer"
              >
                詳細を見る
              </button>
            </div>
          </div>

          {/* FJD AL02 */}
          <div className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-xl transition-shadow border border-gray-100 flex flex-col">
            <div className="mb-6">
              <img 
                src="https://static.readdy.ai/image/b1b0be4a533f8dd52f529875d332f87d/7cb9412fa5598ff3798d691af4b43407.webp"
                alt="FJD AL02"
                className="w-full h-64 object-cover rounded-lg"
              />
            </div>
            
            <div className="mb-4 flex flex-wrap gap-2">
              <span className="inline-block px-3 py-1 bg-[#76B947] text-white text-sm rounded-full">
                FJDynamics
              </span>
              <span className="inline-block px-3 py-1 bg-gray-100 text-gray-700 text-sm rounded-full">
                RTKレベラーシステム
              </span>
            </div>

            <h3 className="text-2xl font-bold text-[#2A6041] mb-4">FJD AL02</h3>
            
            <p className="text-gray-600 mb-6 leading-relaxed min-h-[3rem]">
              10.1インチモニターで精密制御。<br />
              水田の水管理効率を大幅改善。
            </p>

            <div className="space-y-3 mb-8 min-h-[8rem]">
              <div className="flex items-start text-sm text-gray-700">
                <div className="w-5 h-5 flex items-center justify-center mr-3 mt-0.5 flex-shrink-0">
                  <i className="ri-navigation-line text-[#76B947]"></i>
                </div>
                <span>RTK精度 ±2.5cm の高精度レベリング</span>
              </div>
              <div className="flex items-start text-sm text-gray-700">
                <div className="w-5 h-5 flex items-center justify-center mr-3 mt-0.5 flex-shrink-0">
                  <i className="ri-settings-line text-[#76B947]"></i>
                </div>
                <span>レベラー作業専用設計</span>
              </div>
              <div className="flex items-start text-sm text-gray-700">
                <div className="w-5 h-5 flex items-center justify-center mr-3 mt-0.5 flex-shrink-0">
                  <i className="ri-user-line text-[#76B947]"></i>
                </div>
                <span>水田農家、圃場整備事業者向け</span>
              </div>
            </div>

            <div className="mt-auto">
              <button 
                onClick={() => handleViewDetails('fjd-al02')}
                className="w-full py-3 rounded-lg font-semibold whitespace-nowrap transition-colors bg-[#76B947] text-white hover:bg-[#2A6041] cursor-pointer"
              >
                詳細を見る
              </button>
            </div>
          </div>

          {/* FJD ATS */}
          <div className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-xl transition-shadow border border-gray-100">
            <div className="mb-6">
              <img 
                src="https://static.readdy.ai/image/b1b0be4a533f8dd52f529875d332f87d/b4f9f6d5bad9bb14dc10a69a0ab2c3ac.webp"
                alt="FJD ATS"
                className="w-full h-64 object-cover rounded-lg"
              />
            </div>
            
            <div className="mb-4 flex flex-wrap gap-2">
              <span className="inline-block px-3 py-1 bg-[#76B947] text-white text-sm rounded-full">
                FJDynamics
              </span>
              <span className="inline-block px-3 py-1 bg-gray-100 text-gray-700 text-sm rounded-full">
                精密スプレーシステム
              </span>
            </div>

            <h3 className="text-2xl font-bold text-[#2A6041] mb-4">FJD ATS</h3>
            
            <p className="text-gray-600 mb-6 leading-relaxed min-h-[3rem]">
              10.1インチモニターで精密制御。<br />
              環境負荷軽減と効果最大化を実現。
            </p>

            <div className="space-y-3 mb-8 min-h-[8rem]">
              <div className="flex items-start text-sm text-gray-700">
                <div className="w-5 h-5 flex items-center justify-center mr-3 mt-0.5 flex-shrink-0">
                  <i className="ri-navigation-line text-[#76B947]"></i>
                </div>
                <span>RTK精度 ±2.5cm の精密散布</span>
              </div>
              <div className="flex items-start text-sm text-gray-700">
                <div className="w-5 h-5 flex items-center justify-center mr-3 mt-0.5 flex-shrink-0">
                  <i className="ri-settings-line text-[#76B947]"></i>
                </div>
                <span>スプレーヤー作業専用システム</span>
              </div>
              <div className="flex items-start text-sm text-gray-700">
                <div className="w-5 h-5 flex items-center justify-center mr-3 mt-0.5 flex-shrink-0">
                  <i className="ri-user-line text-[#76B947]"></i>
                </div>
                <span>大規模畑作農家、防除事業者向け</span>
              </div>
            </div>

            <div className="mt-auto">
              <button 
                onClick={() => handleViewDetails('fjd-ats')}
                className="w-full py-3 rounded-lg font-semibold whitespace-nowrap transition-colors bg-[#76B947] text-white hover:bg-[#2A6041] cursor-pointer"
              >
                詳細を見る
              </button>
            </div>
          </div>

          {/* eSteer 20 MAX */}
          <div className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-xl transition-shadow border border-gray-100">
            <div className="mb-6">
              <img 
                src="https://static.readdy.ai/image/b1b0be4a533f8dd52f529875d332f87d/0ebc2d331fb79d2774321f2dabdc0a90.webp"
                alt="eSteer 20 MAX"
                className="w-full h-64 object-cover rounded-lg"
              />
            </div>
            
            <div className="mb-4 flex flex-wrap gap-2">
              <span className="inline-block px-3 py-1 bg-[#76B947] text-white text-sm rounded-full">
                EFIX
              </span>
              <span className="inline-block px-3 py-1 bg-gray-100 text-gray-700 text-sm rounded-full">
                農機自動操舵システム
              </span>
            </div>

            <h3 className="text-2xl font-bold text-[#2A6041] mb-4">eSteer 20 MAX</h3>
            
            <p className="text-gray-600 mb-6 leading-relaxed min-h-[3rem]">
              12インチモニターで革新的操舵。<br />
              最新テクノロジーで農作業を変革。
            </p>

            <div className="space-y-3 mb-8 min-h-[8rem]">
              <div className="flex items-start text-sm text-gray-700">
                <div className="w-5 h-5 flex items-center justify-center mr-3 mt-0.5 flex-shrink-0">
                  <i className="ri-navigation-line text-[#76B947]"></i>
                </div>
                <span>RTK精度 ±2.5cm の高精度測位（※1）</span>
              </div>
              <div className="flex items-start text-sm text-gray-700">
                <div className="w-5 h-5 flex items-center justify-center mr-3 mt-0.5 flex-shrink-0">
                  <i className="ri-speed-line text-[#76B947]"></i>
                </div>
                <span>超低速（0.1km/h）〜高速（30km/h）対応</span>
              </div>
              <div className="flex items-start text-sm text-gray-700">
                <div className="w-5 h-5 flex items-center justify-center mr-3 mt-0.5 flex-shrink-0">
                  <i className="ri-settings-line text-[#76B947]"></i>
                </div>
                <span>ISOBUS（VT/TC-SC/TC-GEO）対応</span>
              </div>
              <div className="flex items-start text-sm text-gray-700">
                <div className="w-5 h-5 flex items-center justify-center mr-3 mt-0.5 flex-shrink-0">
                  <i className="ri-user-line text-[#76B947]"></i>
                </div>
                <span>先進農業を目指す農家、大規模経営向け</span>
              </div>
            </div>

            <div className="mt-auto">
              <button 
                onClick={() => handleViewDetails('esteer-20-max')}
                className="w-full py-3 rounded-lg font-semibold whitespace-nowrap transition-colors bg-[#76B947] text-white hover:bg-[#2A6041] cursor-pointer"
              >
                詳細を見る
              </button>
            </div>
          </div>

          {/* eSteer 20 */}
          <div className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-xl transition-shadow border border-gray-100">
            <div className="mb-6">
              <img 
                src="https://static.readdy.ai/image/b1b0be4a533f8dd52f529875d332f87d/0ebc2d331fb79d2774321f2dabdc0a90.webp"
                alt="eSteer 20"
                className="w-full h-64 object-cover rounded-lg"
              />
            </div>
            
            <div className="mb-4 flex flex-wrap gap-2">
              <span className="inline-block px-3 py-1 bg-[#76B947] text-white text-sm rounded-full">
                EFIX
              </span>
              <span className="inline-block px-3 py-1 bg-gray-100 text-gray-700 text-sm rounded-full">
                農機自動操舵システム
              </span>
            </div>

            <h3 className="text-2xl font-bold text-[#2A6041] mb-4">eSteer 20</h3>
            
            <p className="text-gray-600 mb-6 leading-relaxed min-h-[3rem]">
              10インチモニターでシンプル操作。<br />
              導入しやすい自動操舵の入門モデル。
            </p>

            <div className="space-y-3 mb-8 min-h-[8rem]">
              <div className="flex items-start text-sm text-gray-700">
                <div className="w-5 h-5 flex items-center justify-center mr-3 mt-0.5 flex-shrink-0">
                  <i className="ri-navigation-line text-[#76B947]"></i>
                </div>
                <span>RTK精度 ±2.5cm の安定測位</span>
              </div>
              <div className="flex items-start text-sm text-gray-700">
                <div className="w-5 h-5 flex items-center justify-center mr-3 mt-0.5 flex-shrink-0">
                  <i className="ri-speed-line text-[#76B947]"></i>
                </div>
                <span>超低速（0.1km/h）〜高速（30km/h）対応</span>
              </div>
              <div className="flex items-start text-sm text-gray-700">
                <div className="w-5 h-5 flex items-center justify-center mr-3 mt-0.5 flex-shrink-0">
                  <i className="ri-settings-line text-[#76B947]"></i>
                </div>
                <span>クラシック・プロフェッショナルモード切替</span>
              </div>
              <div className="flex items-start text-sm text-gray-700">
                <div className="w-5 h-5 flex items-center justify-center mr-3 mt-0.5 flex-shrink-0">
                  <i className="ri-user-line text-[#76B947]"></i>
                </div>
                <span>中小規模農場、自動操舵入門者向け</span>
              </div>
            </div>

            <div className="mt-auto">
              <button 
                onClick={() => handleViewDetails('esteer-20')}
                className="w-full py-3 rounded-lg font-semibold whitespace-nowrap transition-colors bg-[#76B947] text-white hover:bg-[#2A6041] cursor-pointer"
              >
                詳細を見る
              </button>
            </div>
          </div>
        </div>

        {/* 補足情報 */}
        <div className="mt-12 text-center">
          <p className="text-sm text-gray-600">
            ※1：RTK精度 ±2.5cm は、RTKまたはSkyTrix等の補正サービス利用時の達成可能精度です。<br />
            SkyTrixは基地局やネットワーク信号が不要な独自の測位モードで、収束時間は5分未満です。
          </p>
        </div>
      </div>
    </section>
  );
}
